<template>
  <div class="containerCreateRegistrant pa-3">
    <v-stepper v-model="e1">
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="12" class="text-left">
                <p>{{ $t('page.events.createRegistrant.text1') }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" class="text-left">
                <v-text-field
                  v-model="findByEmail"
                  :label="$t('page.events.createRegistrant.findByEmail')"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="5" sm="5" class="text-left">
                <v-btn class="ma-2 newseriesbtn" style="margin-top: 0px !important" @click="searchUsers('emailAddress')">
                  <v-icon left dark>fa-search</v-icon>
                  {{ $t('page.events.createRegistrant.searchByEmail')}}
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" sm="6" class="text-left">
                <v-text-field
                  v-model="findByLastName"
                  :label="$t('page.events.createRegistrant.findByLastName')"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="5" sm="5" class="text-left">
                <v-btn class="ma-2 newseriesbtn" style="margin-top: 0px !important" @click="searchUsers('lastName')">
                  <v-icon left dark>fa-search</v-icon>
                  {{ $t('page.events.createRegistrant.searchByLastName')}}
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" sm="6" class="text-left">
                <v-text-field
                  v-model="findByLLId"
                  :label="$t('page.events.createRegistrant.findByLLId')"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="5" sm="5" class="text-left">
                <v-btn class="ma-2 newseriesbtn" style="margin-top: 0px !important" @click="searchUsers('id')">
                  <v-icon left dark>fa-search</v-icon>
                  {{ $t('page.events.createRegistrant.searchByLLId')}}
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" class="text-left">
                <p>{{ $t('page.events.createRegistrant.text2') }} {{ $t('page.events.createRegistrant.text3') }}</p>
              </v-col>
            </v-row>

            <v-row align="center">
              <v-col cols="12" sm="12">
                <v-card>
                  <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="searchResult"
                    :single-select="singleSelect"
                    :items-per-page="5"
                    item-key="livelapId"
                    show-select
                    class="elevation-1"
                    hide-default-header
                    :footer-props="{
                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                    }"
                    :no-data-text="$t('dataTable.noDataText')"
                    :headerProps="{
                        'sort-by-text': $t('dataTable.sortByText')
                    }"
                  >
                  <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th v-for="(h, i) in headers" :key="i">{{ h.text }}</th>                  
                        </tr>
                      </thead>
                    </template>
                    <template v-slot:item="props">
                      <tr>
                        <td><v-checkbox :input-value="props.isSelected" @change="props.select($event)"></v-checkbox></td>
                        <td>{{ props.item.id }}</td>
                        <td>{{ props.item.firstName }}</td>
                        <td>{{ props.item.lastName }}</td>
                        <td>{{ props.item.rcnumber }}</td>
                        <td>{{ props.item.raceName }}</td>
                        <td>{{ props.item.emailAddress }}</td>
                        <td>{{ props.item.organization_name }}</td>
                        <td v-if="props.item.promoterValid != 1">
                          <span class="text-danger">{{ $t('page.events.createRegistrant.membership_expired') }}</span>
                        </td>
                        <td v-if="props.item.promoterValid == 1">
                          <strong>{{ $t('page.events.createRegistrant.valid_membership') }}</strong>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

          <v-alert :color="type" text :type="type" value="true" v-if="type">{{ alertText }}</v-alert>
          <v-btn
            color="primary"
            @click="selectValidate(3)"
          >{{ $t('page.events.createRegistrant.manuallyCreateRegistrant') }}</v-btn>
          <v-btn
            color="primary"
            @click="selectValidate(2)"
          >{{ $t('page.events.createRegistrant.continue') }}</v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-row justify="center">
            <v-expansion-panels accordion :value="[0, 1]" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('page.events.createRegistrant.rgistrantInformation') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container>
                    <v-row justify="space-between">
                      <v-col cols="12" md="4">
                        <v-form ref="form">
                          <v-select
                            v-model="registrantDetails.class"
                            :items="classes"
                            :label="$t('page.events.createRegistrant.class')"
                            item-text="name"
                            item-value="id"
                            :no-data-text="$t('common.no_data')"
                          ></v-select>
                          <v-row>
                            <v-col cols="12" md="7">
                              <v-text-field
                                v-model="registrantDetails.position"
                                :label="$t('page.events.createRegistrant.position')"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-btn
                                color="primary"
                              >{{$t('page.events.createRegistrant.printNumber')}}</v-btn>
                            </v-col>
                          </v-row>
                          <v-text-field
                            v-model="registrantDetails.transponder"
                            :label="$t('page.events.createRegistrant.transponder.title')"
                          ></v-text-field>
                          <v-select
                            v-model="registrantDetails.brand"
                            :items="brands"
                            :label="$t('page.events.createRegistrant.brands')"
                            item-text="name"
                            item-value="id"
                            :no-data-text="$t('common.no_data')"
                          ></v-select>
                        </v-form>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-checkbox
                          v-model="registrantDetails.reserved"
                          :label="$t('page.events.createRegistrant.reserved')"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="registrantDetails.waiting_list"
                          :label="$t('page.events.createRegistrant.waitingList')"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="registrantDetails.shown_up"
                          :label="$t('page.events.createRegistrant.shownUp')"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="registrantDetails.in_payment"
                          :label="$t('page.events.createRegistrant.inPayment')"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('page.events.createRegistrant.registrantProfile') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container>
                    <v-row style="text-align: left;">
                      <v-col cols="12" md="4">
                        <p>{{ $t('page.events.createRegistrant.liveLapsId') }}: xxx</p>
                        <p>{{ $t('page.events.createRegistrant.firstName') }}: xxx</p>
                        <p>{{ $t('page.events.createRegistrant.lastName') }}: xxx</p>
                        <p>{{ $t('page.events.createRegistrant.email') }}: xxx</p>
                        <p>{{ $t('page.events.createRegistrant.dob') }}: xxx</p>
                      </v-col>
                      <v-col cols="12" md="4">
                        <p>{{ $t('page.events.createRegistrant.address') }}Address: xxx</p>
                        <p>{{ $t('page.events.createRegistrant.city') }}City: xxx</p>
                        <p>{{ $t('page.events.createRegistrant.stateProvince') }}: xxx</p>
                        <p>{{ $t('page.events.createRegistrant.postalZip') }}: xxx</p>
                        <p>{{ $t('page.events.createRegistrant.country') }}: xxx</p>
                      </v-col>
                      <v-col cols="12" md="4">
                        <p>{{ $t('page.events.createRegistrant.gender') }}: xxx</p>
                        <p>{{ $t('page.events.createRegistrant.phone') }}: xxx</p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('page.events.createRegistrant.transponder.title') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <Transponder />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('page.events.createRegistrant.emergencyContact.title') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <EmergencyContact />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('page.events.createRegistrant.membership') }}</v-expansion-panel-header>
                <v-expansion-panel-content>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('page.events.createRegistrant.commentsNotes') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row style="text-align: center;">
                    <v-col cols="12" md="12">
                      <v-container fluid>
                        <v-textarea
                          autocomplete="comments"
                          v-model="registrantDetails.comments"
                          :label="$t('page.events.createRegistrant.comments')"
                        ></v-textarea>
                      </v-container>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-container fluid>
                        <v-textarea
                          autocomplete="notes"
                          v-model="registrantDetails.notes"
                          :label="$t('page.events.createRegistrant.notes')"
                        ></v-textarea>
                      </v-container>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
          <br />
          <v-btn color="primary" @click="e1 = 1">Back</v-btn>
          <v-btn color="primary">Save</v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-row justify="center">
            <v-expansion-panels accordion :value="[0, 1]" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('page.events.createRegistrant.registrantProfile') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container>
                    <v-row style="text-align: left;">
                      <v-col cols="12" md="4">
                        <v-form ref="form">
                          <v-text-field
                            v-model="registrantDetails.firstName"
                            :label="$t('page.events.createRegistrant.firstName')"
                          ></v-text-field>
                          <v-text-field
                            v-model="registrantDetails.lastName"
                            :label="$t('page.events.createRegistrant.lastName')"
                          ></v-text-field>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('page.events.createRegistrant.rgistrantInformation') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container>
                    <v-row justify="space-between">
                      <v-col cols="12" md="4">
                        <v-form ref="form">
                          <v-select
                            v-model="registrantDetails.class"
                            :items="classes"
                            :label="$t('page.events.createRegistrant.class')"
                            item-text="name"
                            item-value="id"
                            :no-data-text="$t('common.no_data')"
                          ></v-select>
                          <v-row>
                            <v-col cols="12" md="7">
                              <v-text-field
                                v-model="registrantDetails.position"
                                :label="$t('page.events.createRegistrant.position')"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-btn
                                color="primary"
                              >{{$t('page.events.createRegistrant.printNumber')}}</v-btn>
                            </v-col>
                          </v-row>
                          <v-text-field
                            v-model="registrantDetails.transponder"
                            :label="$t('page.events.createRegistrant.transponder.title')"
                          ></v-text-field>
                          <v-select
                            v-model="registrantDetails.brand"
                            :items="brands"
                            :label="$t('page.events.createRegistrant.brands')"
                            item-text="name"
                            item-value="id"
                            :no-data-text="$t('common.no_data')"
                          ></v-select>
                        </v-form>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-checkbox
                          v-model="registrantDetails.reserved"
                          :label="$t('page.events.createRegistrant.reserved')"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="registrantDetails.waiting_list"
                          :label="$t('page.events.createRegistrant.waitingList')"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="registrantDetails.shown_up"
                          :label="$t('page.events.createRegistrant.shownUp')"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="registrantDetails.in_payment"
                          :label="$t('page.events.createRegistrant.inPayment')"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('page.events.createRegistrant.transponder.title') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <Transponder />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('page.events.createRegistrant.emergencyContact.title') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <EmergencyContact />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('page.events.createRegistrant.membership') }}</v-expansion-panel-header>
                <v-expansion-panel-content>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('page.events.createRegistrant.commentsNotes') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row style="text-align: center;">
                    <v-col cols="12" md="12">
                      <v-container fluid>
                        <v-textarea
                          autocomplete="comments"
                          v-model="registrantDetails.comments"
                          :label="$t('page.events.createRegistrant.comments')"
                        ></v-textarea>
                      </v-container>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-container fluid>
                        <v-textarea
                          autocomplete="notes"
                          v-model="registrantDetails.notes"
                          :label="$t('page.events.createRegistrant.notes')"
                        ></v-textarea>
                      </v-container>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
          <br />
          <v-btn color="primary" @click="e1 = 1">Back</v-btn>
          <v-btn color="primary">Save</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import Transponder from "../../../components/registration/Transponder";
import EmergencyContact from "../../../components/registration/EmergencyContact";
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
  mixins: [apiCalls],
  name: "CreateRegistrant",
  components: {
    Transponder,
    EmergencyContact
  },
  data() {
    return {
      findByLLId: null,
      findByEmail: null,
      findByLastName: null,
      e1: 1,
      eventId: this.$route.params.id,
      singleSelect: true,
      selected: [],
      searchResult: [],
      type: null,
      elapse: null,
      alertText: null,
      registrantDetails: {
        class: null,
        position: null,
        brand: null,
        transponder: null,
        reserved: false,
        waiting_list: false,
        shown_up: false,
        in_payment: false,
        comments: null,
        notes: null
      },
      classes: [
        { id: 1, name: "PN" },
        { id: 2, name: "TX" },
        { id: 3, name: "RY" }
      ],
      brands: [
        { id: 1, name: "Yamaha" },
        { id: 2, name: "Ferrari" },
        { id: 3, name: "Lambo" }
      ]
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('page.events.createRegistrant.liveLapsId'), value: "id" },
        { text: this.$t('page.events.createRegistrant.firstName'), value: "firstName" },
        { text: this.$t('page.events.createRegistrant.lastName'), value: "lastName" },
        { text: this.$t('page.events.createRegistrant.number'), value: "rcnumber" },
        { text: this.$t('page.events.createRegistrant.class'), value: "raceName" },
        { text: this.$t('page.events.createRegistrant.email'), value: "emailAddress" },
        { text: this.$t('page.events.createRegistrant.organizationName'), value: "organization_name" },
        { text: this.$t('page.events.createRegistrant.membershipStatus'), value: "promoterValid" }
      ];
    }
  },
  methods: {
    async searchUsers(param){
      
      let value = '';
      if(param == 'emailAddress'){
        value = this.findByEmail;
      } else if(param == 'lastName'){
        value = this.findByLastName;
      } else {
        value = this.findByLLId;
      }

      const response = await this.api(
        "get",
        `/api/v1/promoter/registrant/search/${this.$route.params.id}/${param}/${value}`
      );

      if(response.success == 1){
        this.searchResult = response.message;
      }
    },
    selectValidate(numberPage) {
      if (this.selected.length >= 1) {
        this.e1 = numberPage;
      } else {
        this.showAlert("error", this.$t('page.events.createRegistrant.pleaseSelectOneUser'));
      }
    },
    showAlert(type, text) {
      this.type = type;
      this.alertText = text;
      let timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null;
      }, 3000);

      this.elapse = 1;
      let t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 1000);
    }
  }
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>